import { render, staticRenderFns } from "./main-text-banner.vue?vue&type=template&id=8ed87f5c&scoped=true&"
import script from "./main-text-banner.vue?vue&type=script&lang=js&"
export * from "./main-text-banner.vue?vue&type=script&lang=js&"
import style0 from "./main-text-banner.vue?vue&type=style&index=0&id=8ed87f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed87f5c",
  null
  
)

export default component.exports